import pLimit from 'p-limit';

const juggle = async (threads, promises) => {
  let limit = pLimit(threads);
  return await Promise.all(promises.map(p => limit(p)));
}

export default juggle;
